<template lang="html">
    <div class="d-flex flex-fill">
        <div class="container py-3">
            <div class="row justify-content-center h-100">
                <div class="col-sm-12">
                    <div class="d-flex flex-column w-100 h-100">
                        <div class="flex-grow-1">
                            <h3 class="mb-2 bold fs-normal d-flex justify-content-between">
                                <span>Billing Details</span>
                            </h3>
                            <tab-billing-details v-if="reservation" :reservation="reservation" :readOnly="isReservationReadOnly && reservation.status != -5 || getIsSavingReservation" :showInvoiceBtn="false"></tab-billing-details>

                            <div v-if="reservation && reservation.bookingInvoices && reservation.bookingInvoices.length > 0" class="tab-invoices__invoice-list--limited mb-3 panel p-0 border-top-lightest">
                                <invoice-list :invoiceList="reservation.bookingInvoices" @toggleInvoiceModal="toggleInvoiceModal"></invoice-list>
                            </div>

                            <div v-else-if="getShowInvoiceOption" class="dark fs-large text-center m-5 mt-5">It seems you have no invoices.
                            </div>
                        </div>

                        <div class="d-flex justify-content-end align-items-center text-right border-top-medium pt-2" v-if="isToShowInvoicing">
                            <div class="col-3">
                                <v-select 
                                    v-if="!getIsDocumentTypesLoading"
                                    :options="documentTypesOptions"
                                    label="label"
                                    :value="documentTypeSelected"
                                    @input="updateDocType"
                                />
                            </div>

                            <div v-if="getIsDocumentTypesLoading">
                                <loader></loader>
                            </div>

                            <button :disabled="getIsSavingReservation || isReservationReadOnly && reservation.status != -5 || !getShowInvoiceOption || !documentTypeSelected" class="btn blue btn-height" @click="startCreateInvoice" v-tooltip="disableTooltip">Create Invoice</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InvoiceList from './InvoiceList'
import { reservationsMixin } from '@/mixins/reservations'
import TabBillingDetails from '@/components/reservations/NewReservation/Resume/Details/BillingDetails'
import { mapGetters, mapActions } from 'vuex'
import extendedVSelect from '@/extends/vue-select'
import Loader from '@/tools/loaders/loader1'

export default {
    data() {
        return {
            documentTypeSelected: null,
        }
    },
    async created() {
        if (this.getDocumentTypes.length === 0) {
            await this.requestDocumentTypes();
        }
        
        this.documentTypeSelected = this.getDocumentTypes.find(item => item.isDefault);
        this.setSelectedDocumentType(this.documentTypeSelected);
    },
    props: {
        reservation: {
            type: Object,
            required: true
        }
    },
    computed:{
        ...mapGetters([
            'getIsSavingReservation',
            'getShowInvoiceOption',
            'getInvoiceSystemIntegration',
            'getIsDocumentTypesLoading',
            'getDocumentTypes',
            'getUserIntegrations'
        ]),
        isToShowInvoicing() {
            return this.getUserIntegrations && this.getUserIntegrations.some(integration => integration.type === 'Invoincing');
        },
        documentTypesOptions() {
            return this.getDocumentTypes.filter(i => i.id !== 'PF' && i.id !== 'NC');
        },
        invoiceSystemLogo() {
            if (this.getInvoiceSystemIntegration && this.getInvoiceSystemIntegration.logo && this.getInvoiceSystemIntegration.logo.color) {
                return this.getInvoiceSystemIntegration.logo.color;
            } else {
                return null;
            }
        },
        disableTooltip() {
            if (!this.getShowInvoiceOption) {
                return "You have no integration with invoicing system";
            }
        },
    },
    mixins: [
        reservationsMixin
    ],
    methods: {
        ...mapActions([
                'requestDocumentTypes',
                'setSelectedDocumentType'
        ]),
        updateDocType(event) {
            this.setSelectedDocumentType(event);
        },
        startCreateInvoice() {
            if (this.reservationHasUnsavedChanges) {
                this.$dialog.alert(
                    `<div class="d-flex flex-column justify-content-center">
                        <div class="fs-largest font-weight-600 mb-4">There are unsaved changes!</div>
                        <div class="bold dark">You must save the reservation before invoicing.</div>
                    </div>`,
                    { okText: 'Yes', cancelText: 'No' })

                return false;
            }

            this.eventHub.$emit('editReservation_toggleCreateInvoice');
        },
        toggleInvoiceModal() {
            this.$emit('toggleInvoiceModal');
        },
    },
    components: {
        InvoiceList,
        TabBillingDetails,
        vSelect: extendedVSelect,
        Loader,
    }
}
</script>

<style lang="scss" scoped>
    .btn-height {
        height: 39px;
    }

    .tab-invoices__invoice-list {
        &--limited {
            max-height: 340px;
            overflow: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// TabInvoices.vue?e37c25ae